export enum VariablesListActionType {
  GetListVariables = 'variablesList/getConfigurationVariables',
  GetListVariablesSuccess = 'variablesList/getConfigurationVariablesSuccess',
  GetListVariablesFailure = 'variablesList/getConfigurationVariablesFailure',
  OpenCreateVariablePopup = 'variablesList/openCreateVariablePopup',
  CloseCreateVariablePopup = 'variablesList/closeCreateVariablePopup',
  SetSearchInputValue = 'variablesList/setSearchInputValue',
  ResetVariablesList = 'variablesList/resetVariablesConfiguration',
}
